module.exports = __webpack_public_path__ + "static/scale-model-of-sunken-gardens-in-st.-petersburg-florida-13f6a4c2f757c71c4e55bfdd8f990086.png";